<p-toast></p-toast>
<app-spinner [isLoading]="isLoading"></app-spinner>

<p-dialog header="Parcel Image Details" [(visible)]="displayDialog" [modal]="true" (onHide)="resetModalState()"
  [closable]="true" [style]="{width: '80vw'}">
  @if (displayDialog && selectedRow && !recordNotFound) {
    <app-parcel-detail [parcel]="selectedRow" [hideAssignActions]="true" (notFound)="handleRecordNotFound()"
    (close)="displayDialog = false"></app-parcel-detail>
  } @else {
    <p class="text-danger">Record not found</p>
  }

</p-dialog>

<div class="retrieval-listing-page">
  <div class="listing-shell">
    <div class="table-header">
      <div>
        <!-- <h3>Retrieval Requests</h3>
        <p class="subtitle">Track status and initiate eligible retrievals from one place.</p> -->
      </div>
      <div class="header-actions">
        <!-- <div class="meta-pill">
        <span class="meta-dot"></span>
        {{ retrievalRequests.length }} request(s)
      </div> -->
      <p-button
        icon="pi pi-refresh"
        styleClass="refresh-btn primary-btn-bg"
        [text]="true"
        (onClick)="refreshRequests()"
      ></p-button>
    </div>
  </div>

  <div class="request-summary-grid">
    <div class="summary-card summary-total">
      <span class="summary-label">Total Requests</span>
      <span class="summary-value">{{ getTotalRequestsCount() }}</span>
    </div>
    <div class="summary-card summary-not-initiated">
      <span class="summary-label">User Initiated</span>
      <span class="summary-value">{{ getRequestsCountByStatus('RESTORE_INITIATED') }}</span>
    </div>
    <div class="summary-card summary-available">
      <span class="summary-label">Available</span>
      <span class="summary-value">{{ getRequestsCountByStatus('AVAILABLE') }}</span>
    </div>
    <div class="summary-card summary-inprogress">
      <span class="summary-label">In Progress</span>
      <span class="summary-value">{{ getRequestsCountByStatus('RESTORE_REQUESTED') }}</span>
    </div>
    <div class="summary-card summary-failed">
      <span class="summary-label">Failed</span>
      <span class="summary-value">{{ getRequestsCountByStatus('FAILED') }}</span>
    </div>
  </div>

  <p-table showGridlines
    #dt
    styleClass="retrieval-table"
    size="small"
    [value]="retrievalRequests"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{first} - {last} of {totalRecords}"
    [tableStyle]="{ 'min-width': '70rem' }"
    [sortField]="'requestedAt'"
    [sortOrder]="-1"
    responsiveLayout="scroll"
    >
    <ng-template pTemplate="caption">
      <div class="table-filters">
        <div class="filter-item">
          <label for="itemIdFilter">Item ID</label>
          <input
            id="itemIdFilter"
            pInputText
            type="text"
            [(ngModel)]="filterItemId"
            placeholder="Search by Item ID"
            (input)="applyTableFilters(dt)"
            />
          </div>

          <div class="filter-item">
            <label for="statusFilter">Status</label>
            <p-multiSelect
              inputId="statusFilter"
              [options]="statusFilterOptions"
              [(ngModel)]="selectedStatuses"
              optionLabel="label"
              optionValue="value"
              placeholder="Select status"
              [showClear]="true"
              (onChange)="applyTableFilters(dt)"
              (onClear)="applyTableFilters(dt)"
              appendTo="body"
            ></p-multiSelect>
          </div>

          <p-button
            label="Clear"
            icon="pi pi-filter-slash"
            styleClass="clear-filter-btn primary-btn-bg"
            [text]="true"
            (onClick)="clearTableFilters(dt)"
          ></p-button>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th style="width:200px">Item ID</th>
          <th class="reason-col">Reason for Retrieval</th>
          <th class="date-on-col" pSortableColumn="requestedAt">
            <div class="flex justify-content-between align-items-center w-full">
              <span>Requested On</span>
              <p-sortIcon field="requestedAt"></p-sortIcon>
            </div>
          </th>
          <th class="requested-by-col">Requested By</th>
          <th class="date-on-col">Available Until</th>
          <th class="date-on-col">Status</th>
          <th class="action-col">Action</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-request>
        <tr>
          <td class="item-id">
            @if (canOpenParcelDetails(request.status)) {
              <span class="item-id-text item-id-clickable text-to-button cell-ellipsis"
                (click)="onItemIdClick(request)" [pTooltip]="request.itemId"tooltipPosition="top"
              [tooltipDisabled]="!request.itemId || request.itemId.length <= 22">
                {{ request.itemId }}
              </span>
            }
            @if (!canOpenParcelDetails(request.status)) {
              <span class="item-id-text item-id-disabled cell-ellipsis">
                {{ request.itemId }}
              </span>
            }
          </td>
          <td class="reason-col">
            <span class="cell-ellipsis" [pTooltip]="request.reason" tooltipPosition="top"
              [tooltipDisabled]="!request.reason || request.reason.length <= 45">
              {{ request.reason }}
            </span>
          </td>
          <td class="date-on-col">{{ request.requestedAt | date: 'dd-MM-yyyy HH:mm' }}</td>
          <td class="requested-by-col">
            <span class="cell-ellipsis" [pTooltip]="request.requestedBy" tooltipPosition="top"
              [tooltipDisabled]="!request.requestedBy || request.requestedBy.length <= 28">
              {{ request.requestedBy }}
            </span>
          </td>
          <td class="date-on-col">{{ request.availableUntil | date: 'dd-MM-yyyy HH:mm' }}</td>
          <td>
            <span class="status-indicator" [ngClass]="getStatusIndicatorClass(request.status)">
              <span class="status-dot"></span>
              {{ getStatusDisplayText(request.status) }}
            </span>
          </td>
          <td class="action-col primary-btn-bg">
            <p-button
              label="Initiate Retrieval"
              styleClass="initiate-btn "
              severity="primary"
              size="small"
              [style]="{ width: '150px' }"
              [loading]="loadingItemId === request.itemId"
              [disabled]="!canInitiateRetrieval(request.status) || loadingItemId === request.itemId"
              (onClick)="initiateRetrieval(request)"
            ></p-button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="empty-state">
            <div class="empty-state-content">
              <i class="pi pi-inbox empty-icon"></i>
              <span>No retrieval requests found for your account.</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
